export const PROVIDER_AVAILABILITY_RESOURCE_NAME = 'provider-availability';

export const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const CONTACT_TYPE_LABELS: Record<number, string> = {
  0: 'Any',
  1: 'In Person',
  2: 'Virtual',
  3: 'Phone',
};

export const CONTACT_TYPE_OPTIONS = [
  { id: '', name: 'All Contact Types' },
  { id: '1', name: 'In Person' },
  { id: '2', name: 'Virtual' },
  { id: '3', name: 'Phone' },
];

// Capacity color coding: how many providers in a slot
export const CAPACITY_COLORS = {
  1: '#FFA726', // amber - single provider
  2: '#6F59A5', // purple (brand) - two providers
  3: '#66BB6A', // green - three or more
} as const;

// Contact type chip colors
export const CONTACT_TYPE_COLORS: Record<number, string> = {
  0: '#9E9E9E', // grey - any
  1: '#FF8042', // orange - in person
  2: '#6F59A5', // purple - virtual
  3: '#00C49F', // teal - phone
};

export interface AvailabilitySlot {
  id: string;
  user_id: string;
  day_of_week: number;
  range_start: string;
  range_end: string;
  is_repeating: boolean;
  repeating_availability_id: string | null;
  timezone_abbr: string | null;
  appointment_type_id: string | null;
  contact_type_id: number | null;
  provider_id: number;
  provider_name: string;
  first_name: string;
  last_name: string;
}
